/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seller: NonNullable<unknown> }} Withdrawal_Dialog_NextInputs */

const en_withdrawal_dialog_next = /** @type {(inputs: Withdrawal_Dialog_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We email you a confirmation straight away. ${i?.seller} refunds you within 14 days. If you received a parcel, you send it back within 14 days.`)
};

const pl_withdrawal_dialog_next = /** @type {(inputs: Withdrawal_Dialog_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od razu wyślemy Ci potwierdzenie e-mailem. Sprzedawca (${i?.seller}) zwraca pieniądze w ciągu 14 dni. Jeśli dostajesz przesyłkę, odsyłasz ją w ciągu 14 dni.`)
};

/**
* | output |
* | --- |
* | "We email you a confirmation straight away. {seller} refunds you within 14 days. If you received a parcel, you send it back within 14 days." |
*
* @param {Withdrawal_Dialog_NextInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_dialog_next = /** @type {((inputs: Withdrawal_Dialog_NextInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_Dialog_NextInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_dialog_next(inputs)
	return en_withdrawal_dialog_next(inputs)
});